import type { DocumentData, DocumentSnapshot } from "firebase/firestore";
import type { CourseLesson } from "../../model/autovioCalendarEvents";
import { autovioCalendarEventConverter } from "./autovioCalendarEventConverter";

export const courseLessonConverter = {
  toFirestore: (_: CourseLesson): DocumentData => {
    throw new Error("Not implemented");
  },

  fromFirestore: (doc: DocumentSnapshot): CourseLesson => {
    const result = autovioCalendarEventConverter.fromFirestore(doc);
    if (result.type === "CourseLesson") {
      return result;
    }
    throw Error(`Document ${doc.ref.path} is not a CourseLesson, but: ${result.type}`);
  },
};
